import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { Button } from './ui/button';

export const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-[#1e5a7a] text-white py-8">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="text-white hover:text-[#f5b800] mb-6"
          >
            <ArrowLeft className="mr-2" size={20} />
            Retour à l'accueil
          </Button>
          <div className="flex items-center gap-4">
            <FileText size={40} className="text-[#f5b800]" />
            <h1 className="text-4xl md:text-5xl font-bold">
              Conditions Générales
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-8">
          
          <section>
            <p className="text-gray-600 mb-6">
              Dernière mise à jour : Mars 2025
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Les présentes Conditions Générales régissent l'utilisation du site web IMMO CONCEPT et les relations entre IMMO CONCEPT et ses clients. En accédant à notre site ou en utilisant nos services, vous acceptez ces conditions dans leur intégralité.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              1. Identification de l'entreprise
            </h2>
            <div className="p-6 bg-gray-50 rounded-xl">
              <p className="font-semibold text-[#1e5a7a]">IMMO CONCEPT</p>
              <p className="text-gray-700">Promoteur immobilier</p>
              <p className="text-gray-700">Route de Berne 223</p>
              <p className="text-gray-700">1066 Épalinges, Suisse</p>
              <p className="text-gray-700 mt-2">
                Email : info@immoconceptsuisse.com
              </p>
              <p className="text-gray-700">
                Téléphone : +41 (0)79 510 08 55
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              2. Services proposés
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              IMMO CONCEPT est un promoteur immobilier spécialisé dans :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>La promotion et le développement de projets immobiliers</li>
              <li>La vente de biens immobiliers neufs (chalets, appartements, résidences)</li>
              <li>Le conseil en investissement immobilier</li>
              <li>La gestion de projets de construction</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              3. Utilisation du site web
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En utilisant notre site web, vous vous engagez à :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Fournir des informations exactes et complètes lors de vos demandes de contact</li>
              <li>Ne pas utiliser le site à des fins illégales ou non autorisées</li>
              <li>Ne pas tenter d'accéder de manière non autorisée aux systèmes du site</li>
              <li>Respecter les droits de propriété intellectuelle</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              4. Propriété intellectuelle
            </h2>
            <p className="text-gray-700 leading-relaxed">
              L'ensemble du contenu du site (textes, images, logos, graphiques, vidéos) est la propriété exclusive d'IMMO CONCEPT ou de ses partenaires. Toute reproduction, représentation, modification ou exploitation de tout ou partie du contenu du site, sans autorisation écrite préalable d'IMMO CONCEPT, est strictement interdite.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              5. Informations sur les biens immobiliers
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Les informations présentées sur notre site (descriptions, surfaces, prix, images) sont fournies à titre indicatif et peuvent être modifiées sans préavis. Elles ne constituent pas une offre contractuelle. Les caractéristiques définitives des biens sont précisées dans les documents contractuels de vente. Les images et rendus 3D présentés sont des représentations artistiques et peuvent différer du produit final.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              6. Processus de vente
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              La vente de nos biens immobiliers suit le processus suivant :
            </p>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-4">
              <li>Prise de contact et expression d'intérêt</li>
              <li>Visite du bien ou présentation détaillée du projet</li>
              <li>Remise de la documentation technique et commerciale</li>
              <li>Négociation et accord sur les conditions</li>
              <li>Signature d'un contrat de réservation (le cas échéant)</li>
              <li>Signature de l'acte de vente devant notaire</li>
            </ol>
            <p className="text-gray-700 leading-relaxed mt-4">
              Aucune vente n'est considérée comme définitive avant la signature de l'acte authentique devant notaire.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              7. Prix et paiement
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Les prix affichés sur le site sont en francs suisses (CHF) et sont donnés à titre indicatif. Le prix définitif est celui figurant dans le contrat de vente. Les modalités de paiement sont définies dans les documents contractuels et peuvent inclure un acompte à la réservation, des paiements échelonnés selon l'avancement des travaux, et le solde à la livraison.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              8. Responsabilité
            </h2>
            <p className="text-gray-700 leading-relaxed">
              IMMO CONCEPT s'efforce de fournir des informations exactes et à jour sur son site. Toutefois, nous ne pouvons garantir l'exactitude, l'exhaustivité ou l'actualité de toutes les informations. IMMO CONCEPT ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation du site ou de l'impossibilité d'y accéder.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              9. Liens externes
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Notre site peut contenir des liens vers des sites tiers. Ces liens sont fournis à titre informatif. IMMO CONCEPT n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leurs pratiques de confidentialité.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              10. Modification des conditions
            </h2>
            <p className="text-gray-700 leading-relaxed">
              IMMO CONCEPT se réserve le droit de modifier les présentes Conditions Générales à tout moment. Les modifications entrent en vigueur dès leur publication sur le site. Nous vous encourageons à consulter régulièrement cette page.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              11. Droit applicable et juridiction
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Les présentes Conditions Générales sont régies par le droit suisse. Tout litige relatif à l'interprétation ou à l'exécution des présentes conditions sera soumis à la compétence exclusive des tribunaux du canton de Vaud, Suisse.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              12. Contact
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Pour toute question concernant ces Conditions Générales, vous pouvez nous contacter :
            </p>
            <div className="mt-4 p-6 bg-gray-50 rounded-xl">
              <p className="font-semibold text-[#1e5a7a]">IMMO CONCEPT</p>
              <p className="text-gray-700">Route de Berne 223</p>
              <p className="text-gray-700">1066 Épalinges, Suisse</p>
              <p className="text-gray-700 mt-2">
                Email : <a href="mailto:info@immoconceptsuisse.com" className="text-[#1e5a7a] hover:text-[#f5b800]">info@immoconceptsuisse.com</a>
              </p>
              <p className="text-gray-700">
                Téléphone : <a href="tel:+41795100855" className="text-[#1e5a7a] hover:text-[#f5b800]">+41 (0)79 510 08 55</a>
              </p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};
